import React, { useState } from 'react';
import useUSDRequest from '../../hooks/useUSDRequest';
import dayjs from 'dayjs';
import checkcircleUSD from '../../assets/icons/checkcircleUSD.svg';
import ModalApproveUSD from '../Modals/ModalApproveUSD';
import reverseTransaction from '../../assets/icons/reverseTransaction.svg';
import ModalReturnUSD from '../Modals/ModalReturnUSD';
import { Loader } from '@piggytechng/component-library';
import ModalEditUSDRequestDetails from '../Modals/ModalEditUSDRequestDetails';
import ModalReplaceUSDDocument from '../Modals/ModalReplaceUSDDocument';
import { USD_DOCUMENT_FIELDS } from '../../constants';
import { USDDocumentField } from '../../types';
// import useRolePermissions from '../../hooks/useRolePermissions';

const USDUserDocs = () => {
  const [modalImage, setModalImage] = useState(null);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [showReturnModal, setShowReturnModal] = useState(false);
  const [showEditDetailsModal, setShowEditDetailsModal] = useState(false);
  const [documentToReplace, setDocumentToReplace] = useState<USDDocumentField | null>(null);
  // const { restrictActionByRole } = useRolePermissions({});

  const {
    singleUSDRequest,
    isLoading,
    isLoadingSingleUSDRequests,
    isRefetchingSingUSDRequest,
    generateAccountStatementForUSD,
  } = useUSDRequest();

  const identityImages = [singleUSDRequest?.identity_url_links];

  const utilityURL = singleUSDRequest?.utility_bill_url || '';
  const bankStatement = singleUSDRequest?.bank_statement_url || '';
  const isImage = (url: string) => /\.(jpe?g|png|gif|bmp|webp|svg|heic|heif)$/i.test(url);
  const isPDF = (url: string) => /\.pdf$/i.test(url);
  const openModal = (url: React.SetStateAction<null>) => setModalImage(url);
  const closeModal = () => setModalImage(null);
  const openInNewTab = (url: string | URL | undefined) => window.open(url, '_blank');

  const execution = {
    text: 'Approve Request',
    action: () => {
      // if (restrictActionByRole('usdRequest', 'approved')) return;

      setShowApprovalModal(false);
    },
    buttonText: 'Approve',
    type: '',
    actionColor: '#1734CA',
  };

  const executionReturn = {
    text: 'Return request',
    action: () => {
      // if (restrictActionByRole('usdRequest', 'returned')) return;
      setShowApprovalModal(false);
    },
    buttonText: 'Return',
    type: '',
    actionColor: '#1734CA',
  };

  const titleDocsMap: {
    [x: string]: any;
  } = {
    drivers_licence: "Driver's Licence",
    'international passport': 'International Passport',
    national_id: 'National ID',
  };

  const identityType = String(singleUSDRequest?.identity_type ?? '').toLowerCase();
  const isDriversLicence = identityType.includes('licen');
  // An approved request has already gone to the provider, so it is no longer editable.
  const canEdit = String(singleUSDRequest?.status ?? '').toLowerCase() !== 'approved';

  return (
    <>
      {isRefetchingSingUSDRequest || isLoadingSingleUSDRequests ? (
        <div className="page-loader">
          <Loader color="#ffffff" />
        </div>
      ) : (
        <div className="flex--1">
          <div className="usd-details--docs-wrapper">
            <div className="usd-details--docs">
              <div className="docs-heading flex--2">
                <h1>{titleDocsMap[identityType] ?? 'Identity Document'}</h1>
                {canEdit && (
                  <button type="button" className="edit-btn" onClick={() => setShowEditDetailsModal(true)}>
                    Edit Details
                  </button>
                )}
              </div>
              <div className="info-containter flex--2">
                <div className="info-containter-info flex--4">
                  <label>ID Type</label>
                  <p>{titleDocsMap[singleUSDRequest?.identity_type.toLowerCase()] || 'N/A'}</p>
                </div>
                <div className="info-containter-info flex--4">
                  <label>ID Number</label>
                  <p>{singleUSDRequest?.identity_number || 'N/A'}</p>
                </div>
                <div className="info-containter-info flex--4">
                  <label>Issued Country</label>
                  <p>{singleUSDRequest?.identity_country || 'N/A'}</p>
                </div>
                {singleUSDRequest?.identity_type.toLowerCase() !== 'national_id' && (
                  <>
                    <div className="info-containter-info flex--4">
                      <label>Issued Date</label>

                      <p>{dayjs(String(singleUSDRequest?.identity_issue_date)).format('D MMM YYYY') || 'N/A'}</p>
                    </div>
                    <div className="info-containter-info flex--4">
                      <label>Expiry Date</label>
                      <p>{dayjs(String(singleUSDRequest?.identity_expiry_date)).format('D MMM YYYY') || 'N/A'}</p>
                    </div>
                  </>
                )}
                <div className="info-containter-info flex--4">
                  <label>Address</label>
                  <p>
                    {singleUSDRequest?.address_street_number || ''} {singleUSDRequest?.address_street_name || ''},{' '}
                    {singleUSDRequest?.address_state || ''}, {singleUSDRequest?.address_country || ''}{' '}
                    {singleUSDRequest?.address_postal_code || ''}
                  </p>
                </div>
              </div>
            </div>

            <div className="usd-details--docs">
              <h1>Uploaded Documents</h1>

              <div className="cont flex--1">
                {identityImages.length > 0 && (
                  <div className="flex--4">
                    <h3>Identity Document</h3>
                    <div className="image-grid">
                      {identityImages.map((url: any, i: React.Key | null | undefined) => (
                        <div key={i} className="upload-card">
                          {isImage(url) ? (
                            <>
                              <img src={url} className="image-card" onClick={() => openModal(url)} />
                            </>
                          ) : isPDF(url) ? (
                            <div className="pdf-card" onClick={() => openInNewTab(url)}>
                              📄 PDF Document
                            </div>
                          ) : (
                            <p className="pdf-card">No preview available for file type</p>
                          )}
                          <div className="card-actions flex--2">
                            <button className="download-btn" onClick={() => openInNewTab(url)}>
                              Download
                            </button>
                            {canEdit && (
                              <button
                                className="download-btn replace-btn"
                                onClick={() => setDocumentToReplace(USD_DOCUMENT_FIELDS.IDENTITY)}
                              >
                                Replace
                              </button>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div className="flex--4">
                  <h3>Utility Bill</h3>
                  {utilityURL ? (
                    <div className="image-grid">
                      <div className="upload-card">
                        {isImage(utilityURL) ? (
                          <div
                            className="image-card"
                            style={{ backgroundImage: `url(${utilityURL})` }}
                            onClick={() => openModal(utilityURL)}
                          />
                        ) : isPDF(utilityURL) ? (
                          <div className="pdf-card" onClick={() => openInNewTab(utilityURL)}>
                            📄 PDF Document
                          </div>
                        ) : (
                          <p className="pdf-card">Unsupported file type</p>
                        )}
                        <div className="card-actions flex--2">
                          <button className="download-btn" onClick={() => openInNewTab(utilityURL)}>
                            Download
                          </button>
                          {canEdit && (
                            <button
                              className="download-btn replace-btn"
                              onClick={() => setDocumentToReplace(USD_DOCUMENT_FIELDS.UTILITY_BILL)}
                            >
                              Replace
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      <p className="no-doc-text">No Utility Bill available</p>
                      {canEdit && (
                        <button
                          className="download-btn replace-btn generate-btn"
                          onClick={() => setDocumentToReplace(USD_DOCUMENT_FIELDS.UTILITY_BILL)}
                        >
                          Upload Utility Bill
                        </button>
                      )}
                    </>
                  )}
                </div>

                <div className="flex--4">
                  <h3>Bank Statement</h3>
                  {bankStatement ? (
                    <div className="image-grid">
                      <div className="upload-card">
                        {isImage(bankStatement) ? (
                          <div
                            className="image-card"
                            style={{ backgroundImage: `url(${bankStatement})` }}
                            onClick={() => openModal(bankStatement)}
                          />
                        ) : isPDF(bankStatement) ? (
                          <div className="pdf-card" onClick={() => openInNewTab(bankStatement)}>
                            📄 PDF Document
                          </div>
                        ) : (
                          <p className="pdf-card">Unsupported file type</p>
                        )}
                        <div className="card-actions flex--2">
                          <button className="download-btn" onClick={() => openInNewTab(bankStatement)}>
                            Download
                          </button>
                          {canEdit && (
                            <button
                              className="download-btn replace-btn"
                              onClick={() => setDocumentToReplace(USD_DOCUMENT_FIELDS.BANK_STATEMENT)}
                            >
                              Replace
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      <p className="no-doc-text">No Bank Statement available</p>
                      {canEdit && (
                        <button
                          className="download-btn replace-btn generate-btn"
                          onClick={() => setDocumentToReplace(USD_DOCUMENT_FIELDS.BANK_STATEMENT)}
                        >
                          Upload Bank Statement
                        </button>
                      )}
                    </>
                  )}
                  <button
                    className={`download-btn generate-btn ${bankStatement ? 'centered' : ''}`}
                    onClick={generateAccountStatementForUSD}
                    disabled={isLoading}
                  >
                    {isLoading ? 'Generating...' : 'Generate Statement'}
                  </button>
                </div>
              </div>
            </div>

            {modalImage && (
              <div className="modal-backdrop" onClick={closeModal}>
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                  <img src={modalImage} alt="Preview" />
                  <div className="modal-actions">
                    <button onClick={() => openInNewTab(modalImage)}>Download</button>
                    <button className="close-btn" onClick={closeModal}>
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          {singleUSDRequest?.status.toLowerCase() === 'under review' && (
            <div className="usd-details--user-info--approve-buttons flex--4">
              <div className="pointer details flex--2" onClick={() => setShowApprovalModal(true)}>
                <img src={checkcircleUSD} />
                <p>Approve Request</p>
              </div>
              <div className="pointer details flex--2" onClick={() => setShowReturnModal(true)}>
                <img src={reverseTransaction} />
                <p>Return Request</p>
              </div>
            </div>
          )}
        </div>
      )}

      <ModalApproveUSD modalIsOpen={showApprovalModal} setIsOpen={setShowApprovalModal} {...execution} />
      <ModalReturnUSD modalIsOpen={showReturnModal} setIsOpen={setShowReturnModal} {...executionReturn} />

      <ModalEditUSDRequestDetails
        modalIsOpen={showEditDetailsModal}
        setIsOpen={setShowEditDetailsModal}
        request={singleUSDRequest}
      />

      {documentToReplace && (
        <ModalReplaceUSDDocument
          modalIsOpen={!!documentToReplace}
          setIsOpen={() => setDocumentToReplace(null)}
          fileField={documentToReplace}
          isDriversLicence={isDriversLicence}
        />
      )}
    </>
  );
};

export default USDUserDocs;
